import { render, staticRenderFns } from "./PracticeSumupUnitMultiEdit.vue?vue&type=template&id=d89e29f4&scoped=true&"
import script from "./PracticeSumupUnitMultiEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupUnitMultiEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupUnitMultiEdit.vue?vue&type=style&index=0&id=d89e29f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89e29f4",
  null
  
)

export default component.exports